import { type LapPoint } from '../../domain/lap/LapPoint'

export interface CoastingPeriod {
  lapId: string
  timeBasedLocation: LapPoint
  distanceBasedLocation: LapPoint
  coastingIntensity: number // 0 (productive) to 1 (full coasting)
  acceleration: number // m/s² (positive = accel, negative = brake)
  smoothedAcceleration: number // m/s² after Gaussian filtering
  leanAngle?: number // degrees
  speed: number // km/h
  time: string
  distance: number // meters
}

export interface CoastingConfig {
  lowAccelerationThreshold: number // m/s²
  highAccelerationThreshold: number // m/s²
  lowLeanAngleThreshold: number // degrees
  highLeanAngleThreshold: number // degrees
  minimumSpeedForAnalysis: number // km/h
  smoothingWindow: number // data points
}

export const DEFAULT_COASTING_CONFIG: CoastingConfig = {
  lowAccelerationThreshold: 0.3,
  highAccelerationThreshold: 1.2,
  lowLeanAngleThreshold: 5,
  highLeanAngleThreshold: 15,
  minimumSpeedForAnalysis: 40,
  smoothingWindow: 10,
}

export interface CoastingStatistics {
  totalPeriods: number
  averageCoastingIntensity: number
  percentageCoasting: number
}
